import Cookies from 'js-cookie';

const isDev = (process.env.NODE_ENV === 'development');

const host = () => {
	if ( isDev ) {
		// return 'http://192.168.0.161:3000'; // Las Vegas 6293
		return 'http://192.168.0.55:3000'; // Las Vegas 8176
		// return 'http://192.168.1.2:3000'; // Lucknow
	}
	else {
		return 'https://u5j35bvbtg.execute-api.us-east-2.amazonaws.com/latest';
	}
};

const getUserIDKey = () => {
	if ( isDev ) {
		return 'User-Id-Dev';
	}
	else {
		return 'User-Id';
	}
};

const getUserUniqueIDKey = () => {
	if ( isDev ) {
		return 'Unique-User-Id-Dev';
	}
	else {
		return 'Unique-User-Id';
	}
};

const isLoggedIn = () => {
	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID === undefined || uniqueUserID === undefined ) {
		return false;
	}

	return true;
};

const getHeaders = () => {
	let headers = {
		'Accept': 'application/json',
		'Content-Type': 'application/json',
	};

	const userID = Cookies.get(getUserIDKey());
	const uniqueUserID = Cookies.get(getUserUniqueIDKey());

	if ( userID !== undefined && uniqueUserID !== undefined ) {
		headers[getUserIDKey()] = userID;
		headers[getUserUniqueIDKey()] = uniqueUserID;
	}

	// console.log('headers',headers);
	return headers;
};

const apiVersion = () => {
	return 'v1';
};

const sendRequest = async (url, jsonBody) => {
	return fetch(`${host()}/${apiVersion()}${url}`, {
		method: 'POST',
		headers: getHeaders(),
		body: JSON.stringify(jsonBody),
		mode: 'cors',
	})
	.then(response => {
		// console.log('resp bef', JSON.stringify(response))
		if ( response.ok ) {
			return response.json();
		}
		else {
			throw response.statusText;
		}
	})
	.catch(error => {
		console.log('----------req error: ' + url);
		console.log(JSON.stringify(error));
		throw error;
	});
};


const setAuthDetails = (userID, userUniqueID) => {
	Cookies.set(getUserIDKey(), userID.toString() );
	Cookies.set(getUserUniqueIDKey(), userUniqueID.toString() );
};

const removeAuthDetails = () => {
	Cookies.remove(getUserIDKey());
	Cookies.remove(getUserUniqueIDKey());
	Cookies.remove('email');
};

const setUserInfo = (userInfo) => {
	Cookies.set('email', userInfo.email);
};

const getUserEmail = () => {
	return Cookies.get('email');
};

export {
	isDev,

	sendRequest,
	isLoggedIn,
	setAuthDetails,
	setUserInfo,
	getUserEmail,
	removeAuthDetails,
};